export function getCssVarName(cssVar: string): string {
  return cssVar.replace('var(', '').replace(')', '');
}
